module.exports = __webpack_public_path__ + "static/media/head-side-headphones.7b81606b.svg";